// The DSP registry for the smart-link surfaces (shot-12). ONE ordered list drives the per-DSP URL editor,
// the phone-mockup landing preview (DSP buttons), and the lifetime DSP-clicks bar chart, so they can never
// disagree on label/colour/order. Keys are from the `artist.release_dsp_links.dsp` CHECK vocabulary. Brand
// colours are the on-token `--ac-color-p-*` provider palette; `other` has no brand token → the neutral accent.
//
// DEEZER IS NOT A SMART-LINK BUTTON (ART-219, PO 2026-10-01: "replace deezer with amazon music and make it
// 3rd"). Amazon Music sits third; the `deezer` value stays legal in the database so existing rows are kept, but
// no surface offers, previews, charts or publishes it — the public page and the auto-fill drop it server-side too.

export interface DspDef {
  /** The wire key (release_dsp_links.dsp). */
  key: string;
  /** The display label (as the landing page + editor show it). */
  label: string;
  /** The CSS custom property for the brand colour (bar fill + button accent). */
  colorVar: string;
}

export const DSPS: DspDef[] = [
  { key: "spotify", label: "Spotify", colorVar: "--ac-color-p-spotify" },
  { key: "apple", label: "Apple Music", colorVar: "--ac-color-p-apple" },
  { key: "amazon", label: "Amazon Music", colorVar: "--ac-color-p-amazon" },
  { key: "youtube", label: "YouTube Music", colorVar: "--ac-color-p-youtube" },
  { key: "pandora", label: "Pandora", colorVar: "--ac-color-p-pandora" },
  { key: "tidal", label: "Tidal", colorVar: "--ac-color-p-tidal" },
  { key: "other", label: "Other", colorVar: "--ac-color-accent" },
];

const BY_KEY = new Map(DSPS.map((d) => [d.key, d]));

/** Look up a DSP def by key (falls back to a generic "other"-style def for an unknown key). */
export function dspDef(key: string | null | undefined): DspDef {
  return BY_KEY.get(key ?? "") ?? { key: key ?? "other", label: key ?? "Other", colorVar: "--ac-color-accent" };
}
